/**
 * The two primary sections the Tasks Hub groups async items into, by execution state of the prompt:
 * - `NeedsYourInput`: Copilot finished work the user has not seen (or a prompt is blocked/failed).
 * - `InProgress`: Copilot is actively working on the prompt.
 */
export enum TasksHubSection {
    NeedsYourInput = 'needsYourInput',
    InProgress = 'inProgress',
}
